
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as errorHLFY7zwFUrfpprhDfpUcz1_Gwa8d9C_XhlejYbumvDkMeta } from "/opt/buildhome/repo/pages/error.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as termsM_RN9_459iuNVtH23UOLrjvoINYU4b2nnq0grhd_RmiYYMeta } from "/opt/buildhome/repo/pages/terms.vue?macro=true";
import { default as contactxgbCBTXU_45d0XJYTpbmfD1UGZKjSEtzA80xt962KkT7QMeta } from "/opt/buildhome/repo/pages/contact.vue?macro=true";
import { default as cookieshtP6F02lBALtGxPTRKVnvGvawtAS2_45RpkQD0HOTY6WIMeta } from "/opt/buildhome/repo/pages/cookies.vue?macro=true";
import { default as pricingq7hLQznf5sDmVmp1DnapVh77taqjuEWxS1X0_40g810Meta } from "/opt/buildhome/repo/pages/pricing.vue?macro=true";
import { default as privacyArxgULVZ2Zifu3wQfKQ0WvqaXaBxDlpI2F7eal9OET8Meta } from "/opt/buildhome/repo/pages/privacy.vue?macro=true";
import { default as registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta } from "/opt/buildhome/repo/pages/register.vue?macro=true";
import { default as verify_45emailji8bDKYt0hugClQpEWRvEpYdUEwRiXqCe1cjQfKe5OcMeta } from "/opt/buildhome/repo/pages/verify-email.vue?macro=true";
import { default as reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta } from "/opt/buildhome/repo/pages/reset-password.vue?macro=true";
import { default as forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta } from "/opt/buildhome/repo/pages/forgot-password.vue?macro=true";
import { default as success_npuXIIbdD9aBHf8QNIGuzwicqKKB_45kA6_EujlGqonMMeta } from "/opt/buildhome/repo/pages/payment/success.vue?macro=true";
import { default as cancelledWxJ7DKv8bgrUKZyAX4QGJWyo3VTamfx0E6apYaI9l0MMeta } from "/opt/buildhome/repo/pages/payment/cancelled.vue?macro=true";
import { default as provider_45callbackd0NSnmatVunEgbhumHlQmgEJRS0bURmsxbiYY132SqAMeta } from "/opt/buildhome/repo/pages/provider-callback.vue?macro=true";
import { default as index76iE9Y4Jp9VTE4EV_CcD4daXx42K5zzHTatnEwOMCXUMeta } from "/opt/buildhome/repo/pages/[profession]/index.vue?macro=true";
import { default as update_45verify_45emailhWw4gctYOP9n2ZXjwhbJ4tGznHyrxxFhK3F4Fi4drXwMeta } from "/opt/buildhome/repo/pages/update-verify-email.vue?macro=true";
import { default as indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta } from "/opt/buildhome/repo/pages/chat/[profession]/index.vue?macro=true";
import { default as partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta } from "/opt/buildhome/repo/pages/partnership-registration.vue?macro=true";
import { default as indexkyIdFgF_Y0ZGgCUpE1P4xNS_J3WDZ8VEZNxl7BiQc70Meta } from "/opt/buildhome/repo/pages/[profession]/[country]/index.vue?macro=true";
import { default as _91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta } from "/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue?macro=true";
import { default as component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "error___ar",
    path: "/ar/%D8%AE%D8%B7%D8%A3",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___de",
    path: "/de/fehler",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___en",
    path: "/error",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___es",
    path: "/es/error",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___hi",
    path: "/hi/%E0%A4%A4%E0%A5%8D%E0%A4%B0%E0%A5%81%E0%A4%9F%E0%A4%BF",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___ne",
    path: "/ne/%E0%A4%A4%E0%A5%8D%E0%A4%B0%E0%A5%81%E0%A4%9F%E0%A4%BF",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___pt",
    path: "/pt/erro",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___ru",
    path: "/ru/%D0%BE%D1%88%D0%B8%D0%B1%D0%BA%D0%B0",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___tr",
    path: "/tr/hata",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___ur",
    path: "/ur/%D8%AE%D8%B1%D8%A7%D8%A8%DB%8C",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___vi",
    path: "/vi/loi",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___hi",
    path: "/hi",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___ne",
    path: "/ne",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___ur",
    path: "/ur",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___vi",
    path: "/vi",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login___ar",
    path: "/ar/%D8%AA%D8%B3%D8%AC%D9%8A%D9%84-%D8%A7%D9%84%D8%AF%D8%AE%D9%88%D9%84",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/anmeldung",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/iniciar-sesion",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___hi",
    path: "/hi/%E0%A4%B2%E0%A5%89%E0%A4%97%E0%A4%BF%E0%A4%A8",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___ne",
    path: "/ne/%E0%A4%B2%E0%A4%97%E0%A4%87%E0%A4%A8",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___pt",
    path: "/pt/entrar",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___ru",
    path: "/ru/%D0%B2%D0%BE%D0%B9%D1%82%D0%B8",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___tr",
    path: "/tr/giris",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___ur",
    path: "/ur/%D9%84%D8%A7%DA%AF-%D8%A7%D9%86",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___vi",
    path: "/vi/dang-nhap",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "terms___ar",
    path: "/ar/%D8%A7%D9%84%D8%B4%D8%B1%D9%88%D8%B7",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___de",
    path: "/de/nutzungsbedingungen",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___en",
    path: "/terms",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___es",
    path: "/es/terminos",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___hi",
    path: "/hi/%E0%A4%A8%E0%A4%BF%E0%A4%AF%E0%A4%AE-%E0%A4%94%E0%A4%B0-%E0%A4%B6%E0%A4%B0%E0%A5%8D%E0%A4%A4%E0%A5%87%E0%A4%82",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___ne",
    path: "/ne/%E0%A4%A8%E0%A4%BF%E0%A4%AF%E0%A4%AE-%E0%A4%B0-%E0%A4%B6%E0%A4%B0%E0%A5%8D%E0%A4%A4",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___pt",
    path: "/pt/termos",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___ru",
    path: "/ru/%D1%83%D1%81%D0%BB%D0%BE%D0%B2%D0%B8%D1%8F",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___tr",
    path: "/tr/kullanim-sartlari",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___ur",
    path: "/ur/%D8%B4%D8%B1%D8%A7%D8%A6%D8%B7-%D9%88-%D8%B6%D9%88%D8%A7%D8%A8%D8%B7",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___vi",
    path: "/vi/dieu-khoan",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "contact___ar",
    path: "/ar/%D8%A7%D8%AA%D8%B5%D8%A7%D9%84",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "contact___de",
    path: "/de/kontakt",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/contact-us",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "contact___es",
    path: "/es/contacto",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "contact___hi",
    path: "/hi/%E0%A4%B8%E0%A4%82%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%95",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "contact___ne",
    path: "/ne/%E0%A4%B8%E0%A4%82%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%95",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "contact___pt",
    path: "/pt/contato",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "contact___ru",
    path: "/ru/%D0%BA%D0%BE%D0%BD%D1%82%D0%B0%D0%BA%D1%82%D1%8B",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "contact___tr",
    path: "/tr/ileti%C5%9Fim",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "contact___ur",
    path: "/ur/%D8%AA%D9%85%D8%A7%D8%B3",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "contact___vi",
    path: "/vi/lien-hep",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "cookies___ar",
    path: "/ar/%D8%A7%D9%84%D9%83%D9%88%D9%83%D9%8A%D8%B2",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___de",
    path: "/de/cookies",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___en",
    path: "/cookies",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___es",
    path: "/es/cookies",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___hi",
    path: "/hi/%E0%A4%95%E0%A5%81%E0%A4%95%E0%A5%80%E0%A4%9C%E0%A4%BC",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___ne",
    path: "/ne/%E0%A4%95%E0%A5%81%E0%A4%95%E0%A5%80%E0%A4%9C",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___pt",
    path: "/pt/cookies",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___ru",
    path: "/ru/%D0%BA%D1%83%D0%BA%D0%B8",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___tr",
    path: "/tr/cerezler",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___ur",
    path: "/ur/%DA%A9%D9%88%DA%A9%DB%8C%D8%B2",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___vi",
    path: "/vi/cookie",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "pricing___ar",
    path: "/ar/%D8%A7%D9%84%D8%AA%D8%B3%D8%B9%D9%8A%D8%B1",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___de",
    path: "/de/preise",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___en",
    path: "/pricing",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___es",
    path: "/es/precios",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___hi",
    path: "/hi/%E0%A4%AE%E0%A5%82%E0%A4%B2%E0%A5%8D%E0%A4%AF-%E0%A4%A8%E0%A4%BF%E0%A4%B0%E0%A5%8D%E0%A4%A7%E0%A4%BE%E0%A4%B0%E0%A4%A3",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___ne",
    path: "/ne/%E0%A4%AE%E0%A5%82%E0%A4%B2%E0%A5%8D%E0%A4%AF",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___pt",
    path: "/pt/precos",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___ru",
    path: "/ru/%D1%86%D0%B5%D0%BD%D1%8B",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___tr",
    path: "/tr/fiyatlandirma",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___ur",
    path: "/ur/%D9%82%DB%8C%D9%85%D8%AA%D9%88%DA%BA-%DA%A9%D8%A7-%D8%AA%D8%B9%DB%8C%D9%86",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___vi",
    path: "/vi/bang-gia",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "privacy___ar",
    path: "/ar/%D8%A7%D9%84%D8%AE%D8%B5%D9%88%D8%B5%D9%8A%D8%A9",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___de",
    path: "/de/datenschutz",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___en",
    path: "/privacy",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___es",
    path: "/es/privacidad",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___hi",
    path: "/hi/%E0%A4%97%E0%A5%8B%E0%A4%AA%E0%A4%A8%E0%A5%80%E0%A4%AF%E0%A4%A4%E0%A4%BE",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___ne",
    path: "/ne/%E0%A4%97%E0%A5%8B%E0%A4%AA%E0%A4%A8%E0%A5%80%E0%A4%AF%E0%A4%A4%E0%A4%BE",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___pt",
    path: "/pt/privacidade",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___ru",
    path: "/ru/%D0%BA%D0%BE%D0%BD%D1%84%D0%B8%D0%B4%D0%B5%D0%BD%D1%86%D0%B8%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D1%8C",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___tr",
    path: "/tr/gizlilik-politikasi",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___ur",
    path: "/ur/%D8%B1%D8%A7%D8%B2%D8%AF%D8%A7%D8%B1%DB%8C",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___vi",
    path: "/vi/bao-mat",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "register___ar",
    path: "/ar/%D8%AA%D8%B3%D8%AC%D9%8A%D9%84",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___de",
    path: "/de/registrierung",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/register",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___es",
    path: "/es/registro",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___hi",
    path: "/hi/%E0%A4%AA%E0%A4%82%E0%A4%9C%E0%A5%80%E0%A4%95%E0%A4%B0%E0%A4%A3",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___ne",
    path: "/ne/%E0%A4%A6%E0%A4%B0%E0%A5%8D%E0%A4%A4%E0%A4%BE",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___pt",
    path: "/pt/registro",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___ru",
    path: "/ru/%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___tr",
    path: "/tr/kayit",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___ur",
    path: "/ur/%D8%B1%D8%AC%D8%B3%D9%B9%D8%B1",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___vi",
    path: "/vi/dang-ky",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "verify-email___ar",
    path: "/ar/%D8%AA%D8%A3%D9%83%D9%8A%D8%AF-%D8%A7%D9%84%D8%A8%D8%B1%D9%8A%D8%AF-%D8%A7%D9%84%D8%A7%D9%84%D9%83%D8%AA%D8%B1%D9%88%D9%86%D9%8A",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___de",
    path: "/de/email-verifizieren",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___en",
    path: "/verify-email",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___es",
    path: "/es/verificar-correo",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___hi",
    path: "/hi/%E0%A4%88%E0%A4%AE%E0%A5%87%E0%A4%B2-%E0%A4%B8%E0%A4%A4%E0%A5%8D%E0%A4%AF%E0%A4%BE%E0%A4%AA%E0%A4%A8",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___ne",
    path: "/ne/%E0%A4%87%E0%A4%AE%E0%A5%87%E0%A4%B2-%E0%A4%AA%E0%A5%81%E0%A4%B7%E0%A5%8D%E0%A4%9F%E0%A4%BF",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___pt",
    path: "/pt/verificar-email",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___ru",
    path: "/ru/%D0%BF%D0%BE%D0%B4%D1%82%D0%B2%D0%B5%D1%80%D0%B4%D0%B8%D1%82%D1%8C-email",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___tr",
    path: "/tr/email-dogrulama",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___ur",
    path: "/ur/%D8%A7%DB%8C%D9%85%DB%8C%D9%84-%D8%AA%D8%B5%D8%AF%DB%8C%D9%82",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___vi",
    path: "/vi/xac-thuc-email",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "reset-password___ar",
    path: "/ar/%D8%A7%D8%B9%D8%A7%D8%AF%D8%A9-%D8%AA%D8%B9%D9%8A%D9%8A%D9%86-%D9%83%D9%84%D9%85%D8%A9-%D8%A7%D9%84%D9%85%D8%B1%D9%88%D8%B1",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___de",
    path: "/de/passwort-zurucksetzen",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___en",
    path: "/reset-password",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___es",
    path: "/es/restablecer-contrasena",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___hi",
    path: "/hi/%E0%A4%AA%E0%A4%BE%E0%A4%B8%E0%A4%B5%E0%A4%B0%E0%A5%8D%E0%A4%A1-%E0%A4%B0%E0%A5%80%E0%A4%B8%E0%A5%87%E0%A4%9F",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___ne",
    path: "/ne/%E0%A4%AA%E0%A4%BE%E0%A4%B8%E0%A4%B5%E0%A4%B0%E0%A5%8D%E0%A4%A1-%E0%A4%B0%E0%A5%80%E0%A4%B8%E0%A5%87%E0%A4%9F",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___pt",
    path: "/pt/redefinir-senha",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___ru",
    path: "/ru/%D1%81%D0%B1%D1%80%D0%BE%D1%81-%D0%BF%D0%B0%D1%80%D0%BE%D0%BB%D1%8F",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___tr",
    path: "/tr/sifre-sifirlama",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___ur",
    path: "/ur/%D9%BE%D8%A7%D8%B3%D9%88%D8%B1%DA%88-%D8%B1%DB%8C-%D8%B3%DB%8C%D9%B9",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___vi",
    path: "/vi/dat-lai-mat-khau",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "forgot-password___ar",
    path: "/ar/%D8%A7%D8%B3%D8%AA%D8%B9%D8%A7%D8%AF%D8%A9-%D9%83%D9%84%D9%85%D8%A9-%D8%A7%D9%84%D9%85%D8%B1%D9%88%D8%B1",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___de",
    path: "/de/passwort-vergessen",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/forgot-password",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___es",
    path: "/es/recuperar-contrasena",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___hi",
    path: "/hi/%E0%A4%AA%E0%A4%BE%E0%A4%B8%E0%A4%B5%E0%A4%B0%E0%A5%8D%E0%A4%A1-%E0%A4%AD%E0%A5%82%E0%A4%B2-%E0%A4%97%E0%A4%8F",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ne",
    path: "/ne/%E0%A4%AA%E0%A4%BE%E0%A4%B8%E0%A4%B5%E0%A4%B0%E0%A5%8D%E0%A4%A1-%E0%A4%AC%E0%A4%BF%E0%A4%B0%E0%A5%8D%E0%A4%B8%E0%A4%A8%E0%A5%81",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___pt",
    path: "/pt/recuperar-senha",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ru",
    path: "/ru/%D0%B2%D0%BE%D1%81%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%B8%D1%82%D1%8C-%D0%BF%D0%B0%D1%80%D0%BE%D0%BB%D1%8C",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___tr",
    path: "/tr/sifremi-unuttum",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ur",
    path: "/ur/%D9%BE%D8%A7%D8%B3%D9%88%D8%B1%DA%88-%D8%A8%DA%BE%D9%88%D9%84-%DA%AF%D8%A6%DB%92",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___vi",
    path: "/vi/quen-mat-khau",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "payment-success___ar",
    path: "/ar/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___de",
    path: "/de/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___en",
    path: "/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___es",
    path: "/es/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___hi",
    path: "/hi/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___ne",
    path: "/ne/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___pt",
    path: "/pt/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___ru",
    path: "/ru/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___tr",
    path: "/tr/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___ur",
    path: "/ur/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___vi",
    path: "/vi/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-cancelled___ar",
    path: "/ar/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___de",
    path: "/de/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___en",
    path: "/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___es",
    path: "/es/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___hi",
    path: "/hi/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___ne",
    path: "/ne/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___pt",
    path: "/pt/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___ru",
    path: "/ru/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___tr",
    path: "/tr/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___ur",
    path: "/ur/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___vi",
    path: "/vi/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "provider-callback___ar",
    path: "/ar/provider-callback",
    meta: {"middleware":["cookie"]},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___de",
    path: "/de/provider-callback",
    meta: {"middleware":["cookie"]},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___en",
    path: "/provider-callback",
    meta: {"middleware":["cookie"]},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___es",
    path: "/es/provider-callback",
    meta: {"middleware":["cookie"]},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___hi",
    path: "/hi/provider-callback",
    meta: {"middleware":["cookie"]},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___ne",
    path: "/ne/provider-callback",
    meta: {"middleware":["cookie"]},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___pt",
    path: "/pt/provider-callback",
    meta: {"middleware":["cookie"]},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___ru",
    path: "/ru/provider-callback",
    meta: {"middleware":["cookie"]},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___tr",
    path: "/tr/provider-callback",
    meta: {"middleware":["cookie"]},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___ur",
    path: "/ur/provider-callback",
    meta: {"middleware":["cookie"]},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___vi",
    path: "/vi/provider-callback",
    meta: {"middleware":["cookie"]},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "profession___ar",
    path: "/ar/:profession()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___de",
    path: "/de/:profession()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___en",
    path: "/:profession()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___es",
    path: "/es/:profession()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___hi",
    path: "/hi/:profession()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___ne",
    path: "/ne/:profession()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___pt",
    path: "/pt/:profession()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___ru",
    path: "/ru/:profession()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___tr",
    path: "/tr/:profession()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___ur",
    path: "/ur/:profession()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___vi",
    path: "/vi/:profession()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "update-verify-email___ar",
    path: "/ar/%D8%AA%D8%AD%D8%AF%D9%8A%D8%AB-%D8%AA%D8%A3%D9%83%D9%8A%D8%AF-%D8%A7%D9%84%D8%A8%D8%B1%D9%8A%D8%AF",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___de",
    path: "/de/email-aktualisierung-bestatigen",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___en",
    path: "/update-verify-email",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___es",
    path: "/es/actualizar-verificacion-correo",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___hi",
    path: "/hi/%E0%A4%88%E0%A4%AE%E0%A5%87%E0%A4%B2-%E0%A4%85%E0%A4%AA%E0%A4%A1%E0%A5%87%E0%A4%9F-%E0%A4%B8%E0%A4%A4%E0%A5%8D%E0%A4%AF%E0%A4%BE%E0%A4%AA%E0%A4%A8",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___ne",
    path: "/ne/%E0%A4%87%E0%A4%AE%E0%A5%87%E0%A4%B2-%E0%A4%85%E0%A4%AA%E0%A4%A1%E0%A5%87%E0%A4%9F-%E0%A4%AA%E0%A5%81%E0%A4%B7%E0%A5%8D%E0%A4%9F%E0%A4%BF",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___pt",
    path: "/pt/atualizar-verificacao-email",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___ru",
    path: "/ru/%D0%BE%D0%B1%D0%BD%D0%BE%D0%B2%D0%B8%D1%82%D1%8C-%D0%BF%D0%BE%D0%B4%D1%82%D0%B2%D0%B5%D1%80%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D0%B5-email",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___tr",
    path: "/tr/email-guncelleme-dogrulama",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___ur",
    path: "/ur/%D8%A7%DB%8C%D9%85%DB%8C%D9%84-%D8%A7%D9%BE%DA%88%DB%8C%D9%B9-%D8%AA%D8%B5%D8%AF%DB%8C%D9%82",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___vi",
    path: "/vi/cap-nhat-xac-thuc-email",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "chat-profession___ar",
    path: "/ar/%D9%85%D8%AD%D8%A7%D8%AF%D8%AB%D8%A9/:profession()",
    meta: { ...(indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___de",
    path: "/de/chat/:profession()",
    meta: { ...(indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___en",
    path: "/chat/:profession()",
    meta: { ...(indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___es",
    path: "/es/charla/:profession()",
    meta: { ...(indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___hi",
    path: "/hi/%E0%A4%9A%E0%A5%88%E0%A4%9F/:profession()",
    meta: { ...(indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___ne",
    path: "/ne/%E0%A4%9A%E0%A5%8D%E0%A4%AF%E0%A4%BE%E0%A4%9F/:profession()",
    meta: { ...(indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___pt",
    path: "/pt/bate-papo/:profession()",
    meta: { ...(indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___ru",
    path: "/ru/%D1%87%D0%B0%D1%82/:profession()",
    meta: { ...(indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___tr",
    path: "/tr/sohbet/:profession()",
    meta: { ...(indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___ur",
    path: "/ur/%DA%AF%D9%BE%20%D8%B4%D9%BE/:profession()",
    meta: { ...(indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___vi",
    path: "/vi/tro-chuyen/:profession()",
    meta: { ...(indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "partnership-registration___ar",
    path: "/ar/%D8%AA%D8%B3%D8%AC%D9%8A%D9%84-%D8%B4%D8%B1%D8%A7%D9%83%D8%A9",
    meta: partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/partnership-registration.vue")
  },
  {
    name: "partnership-registration___de",
    path: "/de/partnerschafts-registrierung",
    meta: partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/partnership-registration.vue")
  },
  {
    name: "partnership-registration___en",
    path: "/partnership-registration",
    meta: partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/partnership-registration.vue")
  },
  {
    name: "partnership-registration___es",
    path: "/es/registro-de-sociedad",
    meta: partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/partnership-registration.vue")
  },
  {
    name: "partnership-registration___hi",
    path: "/hi/%E0%A4%B8%E0%A4%BE%E0%A4%9D%E0%A5%87%E0%A4%A6%E0%A4%BE%E0%A4%B0%E0%A5%80-%E0%A4%AA%E0%A4%82%E0%A4%9C%E0%A5%80%E0%A4%95%E0%A4%B0%E0%A4%A3",
    meta: partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/partnership-registration.vue")
  },
  {
    name: "partnership-registration___ne",
    path: "/ne/%E0%A4%B8%E0%A4%BE%E0%A4%9D%E0%A5%87%E0%A4%A6%E0%A4%BE%E0%A4%B0%E0%A5%80-%E0%A4%A6%E0%A4%B0%E0%A5%8D%E0%A4%A4%E0%A4%BE",
    meta: partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/partnership-registration.vue")
  },
  {
    name: "partnership-registration___pt",
    path: "/pt/registro-de-parceria",
    meta: partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/partnership-registration.vue")
  },
  {
    name: "partnership-registration___ru",
    path: "/ru/%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BF%D0%B0%D1%80%D1%82%D0%BD%D0%B5%D1%80%D1%81%D1%82%D0%B2%D0%B0",
    meta: partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/partnership-registration.vue")
  },
  {
    name: "partnership-registration___tr",
    path: "/tr/is-ortakligi-kaydi",
    meta: partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/partnership-registration.vue")
  },
  {
    name: "partnership-registration___ur",
    path: "/ur/%D8%B4%D8%B1%D8%A7%DA%A9%D8%AA-%D8%B1%D8%AC%D8%B3%D9%B9%D8%B1%DB%8C%D8%B4%D9%86",
    meta: partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/partnership-registration.vue")
  },
  {
    name: "partnership-registration___vi",
    path: "/vi/dang-ky-doi-tac",
    meta: partnership_45registrationS1m5INardeoYnZFMyJcWtjJyqqRz8eYBRfkLH8n2ERgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/partnership-registration.vue")
  },
  {
    name: "profession-country___ar",
    path: "/ar/:profession()/:country()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___de",
    path: "/de/:profession()/:country()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___en",
    path: "/:profession()/:country()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___es",
    path: "/es/:profession()/:country()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___hi",
    path: "/hi/:profession()/:country()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___ne",
    path: "/ne/:profession()/:country()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___pt",
    path: "/pt/:profession()/:country()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___ru",
    path: "/ru/:profession()/:country()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___tr",
    path: "/tr/:profession()/:country()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___ur",
    path: "/ur/:profession()/:country()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___vi",
    path: "/vi/:profession()/:country()",
    meta: {"middleware":"profession-guard"},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "chat-profession-conversationId___ar",
    path: "/ar/%D9%85%D8%AD%D8%A7%D8%AF%D8%AB%D8%A9/:profession()/:conversationId()",
    meta: { ...(_91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___de",
    path: "/de/chat/:profession()/:conversationId()",
    meta: { ...(_91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___en",
    path: "/chat/:profession()/:conversationId()",
    meta: { ...(_91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___es",
    path: "/es/charla/:profession()/:conversationId()",
    meta: { ...(_91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___hi",
    path: "/hi/%E0%A4%9A%E0%A5%88%E0%A4%9F/:profession()/:conversationId()",
    meta: { ...(_91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___ne",
    path: "/ne/%E0%A4%9A%E0%A5%8D%E0%A4%AF%E0%A4%BE%E0%A4%9F/:profession()/:conversationId()",
    meta: { ...(_91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___pt",
    path: "/pt/bate-papo/:profession()/:conversationId()",
    meta: { ...(_91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___ru",
    path: "/ru/%D1%87%D0%B0%D1%82/:profession()/:conversationId()",
    meta: { ...(_91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___tr",
    path: "/tr/sohbet/:profession()/:conversationId()",
    meta: { ...(_91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___ur",
    path: "/ur/%DA%AF%D9%BE%20%D8%B4%D9%BE/:profession()/:conversationId()",
    meta: { ...(_91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___vi",
    path: "/vi/tro-chuyen/:profession()/:conversationId()",
    meta: { ...(_91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {}), ...{"middleware":"profession-guard"} },
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/ar/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/hi/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/ne/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/pt/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/ru/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/tr/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/ur/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/vi/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  }
]